export default __webpack_public_path__ + "static/media/EDSF-Release-3-Design-Workshop-18-19-July-2018-(UvA).a11420cc.md";